import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import bcrypt from 'bcryptjs';
import { db } from '../lib/db';

export const useAuthStore = create(
  persist(
    (set, get) => ({
      user: null,
      isLoading: false,
      isAuthenticated: false,

      login: async (email, password) => {
        set({ isLoading: true });
        try {
          const user = await db.users.where('email').equals(email).first();
          
          if (!user) {
            throw new Error('Invalid email or password');
          }

          if (user.status !== 'active') {
            throw new Error('Account is inactive');
          }

          const isValid = await bcrypt.compare(password, user.passwordHash);
          
          if (!isValid) {
            throw new Error('Invalid email or password');
          }

          await db.users.update(user.id, { lastLogin: Date.now() });
          
          const safeUser = { ...user };
          delete safeUser.passwordHash;
          
          set({ user: safeUser, isAuthenticated: true, isLoading: false });
          return safeUser;
        } catch (error) {
          set({ isLoading: false });
          throw error;
        }
      },

      logout: () => {
        set({ user: null, isAuthenticated: false });
      },

      updateUser: (updates) => {
        const currentUser = get().user;
        if (currentUser) {
          set({ user: { ...currentUser, ...updates } });
        }
      }
    }),
    {
      name: 'pms-auth',
      partialize: (state) => ({ user: state.user, isAuthenticated: state.isAuthenticated })
    }
  )
);
